// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --footer-background-colour: #333333;
  --footer-link-colour: #fff;
  --nav-bar-background-colour: #fff;
  --product-content-padding: 0 10px;
}

router-outlet + app-home {
  height: 100%;
  position: relative;
}

.home-page-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.home-page-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;
  width: 100%;
  position: absolute;
  top: 1rem;
}

.body {
  height: 100%;
}

.input-container {
  text-align: center;
  width: 547px;
}

.home-page-background-image {
  width: 100%;
}

.home-page-landing {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  position: relative;
  width: 100%;
}

.delivery-tab {
  height: 100%;
  width: 100%;
}

.takeaway-tab {
  width: 434px;
  min-height: 183px;
}
.takeaway-tab-content {
  display: flex;
  justify-content: center;
  width: 100%;
  height: calc(100% - 52px);
}
.takeaway-tab-shouldRedirect {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.home-page-content {
  box-shadow: -1px 2px 30px 0px rgba(0, 0, 0, 0.6);
  background-color: #fff;
  z-index: 9;
}
.home-page-content .mat-mdc-tab-body-wrapper {
  min-height: 213.5px;
}
.home-page-content .mat-mdc-tab-body-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px 20px;
  min-width: 474px;
  min-height: 213px;
  overflow: hidden;
  max-width: 550px;
}
.home-page-content .mdc-tab-indicator__content--underline {
  border-color: #E3000E !important;
}
.home-page-content .mat-mdc-tab {
  width: 50%;
  background-color: rgba(0, 0, 0, 0.12);
  opacity: 0.5;
}
.home-page-content .supports-single-only .mat-mdc-tab {
  width: 100% !important;
}
.home-page-content .mdc-tab--active {
  background-color: unset !important;
  opacity: 1 !important;
}
.home-page-content .mdc-tab__content {
  width: 100%;
  height: 100%;
}
.home-page-content .mdc-text-field--filled .mdc-line-ripple::after {
  border-bottom-color: #E3000E !important;
}

.home-page-content-tab-button {
  font-size: 18px;
  padding: 13px 30px;
  border: 1px solid;
  border-radius: 7px;
  cursor: Pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.home-page-content-tab-button-icon {
  margin: 0 5px;
}

.home-page-content-tab-error {
  margin: 0;
  color: red;
  margin-top: -20px;
  margin-bottom: 25px;
  text-align: center;
}

.home-page-content-tab-form {
  flex: 1;
  width: 100%;
  min-width: 400px;
}

.home-page-content-tab-label {
  margin: 0;
  padding: 10px;
  text-align: center;
  font-family: Tenant-Bold, Courier, Helvetica, sans-serif;
  font-weight: 600 !important;
}

.home-page-content-tab-header {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-top: 3px;
  font-family: Tenant-Bold, Courier, Helvetica, sans-serif;
  color: #000;
}
.home-page-content-tab-header-estimate {
  font-size: 10px;
  line-height: initial;
  text-transform: lowercase;
}
.home-page-content-tab-header-estimate .mat-icon {
  height: 15px;
  width: 15px;
  font-size: 15px;
  margin-right: 3px;
}
.home-page-content-tab-header-label {
  font-weight: bold;
  font-size: 19px;
  line-height: initial;
}

.home-page-content-tab-hasSites {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 15px;
}
.home-page-content-tab-hasSites-content {
  padding: 10px 0 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
}
.home-page-content-tab-hasSites-label {
  font-weight: bold;
  border-bottom: thin solid #E3000E;
  color: #E3000E;
  display: flex;
  align-items: center;
}

.home-page-content-tab-store-item {
  display: flex;
  padding: 6px 6px 6px 3px;
  margin: 0 5px 3px;
  border: thin solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  cursor: pointer;
  flex-direction: column;
  width: calc(50% - 10px);
}
.home-page-content-tab-store-item:hover {
  box-shadow: 0 1px 9px 1px rgba(0, 0, 0, 0.07);
}
.home-page-content-tab-store-item:first-of-type {
  margin: 0 5px 3px 0;
}
.home-page-content-tab-store-item-icon {
  margin: 0 3px;
}
.home-page-content-tab-store-item-label {
  font-weight: bold;
}
.home-page-content-tab-store-item-text {
  font-size: 13px;
}

.tab-button-hasSites {
  margin-top: -10px;
}

.occasion-selector-stores {
  gap: 6px;
  justify-content: center;
  margin-top: 10px;
}

.occasion-selector-stores .card {
  padding: 6px;
  width: calc(50% - 12px);
  cursor: pointer;
}
.occasion-selector-stores .card span:first-of-type {
  font-weight: bold;
}
.occasion-selector-stores .card span, .occasion-selector-stores .card a {
  font-size: 13px;
}
.occasion-selector-stores .card:hover {
  box-shadow: 0 1px 9px 1px rgba(0, 0, 0, 0.07);
}

.stores-default-Item-body {
  margin: 0;
  margin-top: -20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.home-page-landing-copy-container {
  position: relative;
  top: 0;
  padding: 10px 5%;
  text-align: center;
  color: #ffffff;
  width: 100%;
}

.home-page-section-group-details-text {
  color: black;
}

@media screen and (max-width: 1023px) {
  .home-page-landing {
    height: unset;
  }
  .home-page-landing-copy-container h1, .home-page-landing-copy-container h2, .home-page-landing-copy-container h3, .home-page-landing-copy-container h4, .home-page-landing-copy-container h5, .home-page-landing-copy-container p, .home-page-landing-copy-container span {
    line-height: 0.75;
  }
  .home-page-landing-copy-container h1 {
    font-size: 2rem;
  }
  .home-page-landing-copy-container h2 {
    font-size: 1.75rem;
  }
  .home-page-landing-copy-container h3 {
    font-size: 1.5rem;
  }
  .home-page-landing-copy-container h4 {
    font-size: 1.25rem;
  }
  .home-page-landing-copy-container p, .home-page-landing-copy-container span {
    font-size: 1rem;
  }
  .home-page-content {
    box-shadow: none;
    width: 100%;
  }
  .home-page-content .mat-mdc-tab-body-content {
    max-width: unset;
  }
  .home-page-content-wrapper {
    padding-bottom: 0;
    position: initial;
  }
  .home-page-content-card {
    margin: 0;
    box-shadow: none !important;
  }
}
@media screen and (max-width: 479px) {
  .home-page-background {
    width: 100%;
  }
  .home-page-content {
    width: 100%;
  }
  .home-page-content .mat-mdc-tab-body-content {
    min-width: 325px;
  }
  .takeaway-tab {
    width: 100%;
  }
}
@media screen and (max-width: 325px) {
  .home-page-content .mat-mdc-tab-body-content {
    min-width: 280px;
  }
  .home-page-content-tab-label {
    font-size: 20px;
    padding: 10px 0;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
